/** Two positive integers whose sum is less than 10 (answer is 2–9). */
export function randomCaptchaPair() {
  const sum = 2 + Math.floor(Math.random() * 8); // 2 … 9
  const a = 1 + Math.floor(Math.random() * (sum - 1));
  return { a, b: sum - a };
}

/**
 * Server-side check: operands must be valid challenge numbers; answer must match.
 * Accepts captchaA / captchaB from JSON (number or numeric string).
 */
export function verifySignupCaptcha(body) {
  const rawA = body?.captchaA;
  const rawB = body?.captchaB;
  const answerStr = typeof body?.captchaAnswer === 'string' ? body.captchaAnswer.trim() : '';

  const a = typeof rawA === 'number' ? rawA : parseInt(String(rawA ?? ''), 10);
  const b = typeof rawB === 'number' ? rawB : parseInt(String(rawB ?? ''), 10);
  if (!Number.isInteger(a) || !Number.isInteger(b)) return false;
  if (a < 1 || b < 1 || a + b >= 10) return false;

  const ans = parseInt(answerStr, 10);
  if (!Number.isInteger(ans) || ans !== a + b) return false;
  return true;
}
